module.exports = __webpack_public_path__ + "img/banner-01.0e6fd595.jpg";